import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ContactType } from '../models/contactType.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ContactTypeService {
  private apiUrl = environment.apiUrl + '/ContactType';

  http = inject(HttpClient)

  getContactTypes(): Observable<ContactType[]> {
    return this.http.get<ContactType[]>(`${this.apiUrl}/GetContactTypes`)
  }

  getContactTypeById(contactTypeId: number): Observable<ContactType> {
    return this.http.get<ContactType>(`${this.apiUrl}/GetContactTypeById/${contactTypeId}`)
  };
}
